import { memo } from "react";
import { ErrorComponent, noop } from "@swiggy-private/portal-dineout-ui";
import { CURTAIN_RAISER_ERROR } from "./constants";
import { ErrorContainer } from "./styled";

const CurtainError = ({ onCtaClick = noop }: { onCtaClick?: VoidFunction }) => {
    return (
        <ErrorContainer>
            <ErrorComponent
                heading={CURTAIN_RAISER_ERROR.HEADING}
                description={CURTAIN_RAISER_ERROR.DESCRIPTION}
                showCta={true}
                showFullPage={true}
                onCtaClick={onCtaClick}
                ctaText={CURTAIN_RAISER_ERROR.CTA_TEXT}
            />
        </ErrorContainer>
    );
};

export default memo(CurtainError);
